import { api } from '@/api';
import { getLoginExistsResponse } from '@/api/type';

interface getLoginExistsProps {
  loginId: string;
}

/** 로그인ID 중복체크 */
export const getLoginExists = async ({ loginId }: getLoginExistsProps) => {
  try {
    const res = await api.get<getLoginExistsResponse>(
      `api/web/visitors/login-ids/exists?loginId=${loginId}`
    );
    return res.data;
  } catch (err) {
    console.error('getLoginExists API error:', err);
    throw err;
  }
};
